// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://ccmcqsettings.incubation.bridgelabz.com",
  //baseUrl: "https://34.210.101.131:8081",
 // baseUrl: "http://192.168.0.143:8089",
  // baseUrl: "http://192.168.2.7:8081"
   driveUrl: 'https://ccdrivedash.incubation.bridgelabz.com', // 'http://192.168.0.161:8080',
  //driveUrl: 'http://192.168.0.143:8088',

  userServiceUrl: 'https://ccuser.incubation.bridgelabz.com',
  //userServiceUrl: 'http://192.168.0.143:8085',

   campaignDashboardUrl: 'https://cccampdash.incubation.bridgelabz.com',
 // campaignDashboardUrl:'http://192.168.0.143:8087',
  mcqTestUrl:'https://ccmcqresults.incubation.bridgelabz.com/mcq',
 //  mcqTestUrl:'http://192.168.0.143:8090/mcq'

 codinClubUrl:'https://fundoowalkin-backend-stg.incubation.bridgelabz.com'


};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
